const ONELINK_BASE = "https://soonlist.onelink.me/QM97/open";

export const APP_STORE_URL =
  "https://apps.apple.com/us/app/soonlist-save-events-instantly/id6670222216";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.soonlist.app";

export function createOneLink(params: {
  deepLinkValue?: string;
  deepLinkSub1?: string;
  campaign: string;
}): string {
  const query = new URLSearchParams({
    c: params.campaign,
  });
  if (params.deepLinkValue) {
    query.set("deep_link_value", params.deepLinkValue);
  }
  if (params.deepLinkSub1) {
    query.set("deep_link_sub1", params.deepLinkSub1);
  }
  return `${ONELINK_BASE}?${query.toString()}`;
}
